import { parseISO, isValid } from "date-fns";

export const formatLocalIsoDate = (date) => {
    if (date === null || date === undefined || date === "") return "";

    const parsedDate = typeof date === "string" ? parseISO(date) : new Date(date);
    if (!isValid(parsedDate)) return "";

    const year = parsedDate.getFullYear();
    const month = String(parsedDate.getMonth() + 1).padStart(2, "0");
    const day = String(parsedDate.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
};

export const formatDate = (date, options = {}) => {
    // 1) Null/undefined => empty string (UI-safe)
    if (date === null || date === undefined || date === "") return "";

    let validDate;

    // 2) Accept ISO string
    if (typeof date === "string") {
        validDate = parseISO(date);
    }
    // 3) Accept Date instance
    else if (date instanceof Date) {
        validDate = date;
    }
    // 4) Accept numeric timestamps (optional but helpful)
    else if (typeof date === "number") {
        validDate = new Date(date);
    }
    // 5) Anything else => return empty (do NOT crash the whole UI)
    else {
        return "";
    }

    // Validate
    if (!isValid(validDate)) return "";

    const defaultOptions = {
        dateStyle: "medium",
        timeStyle: undefined,
    };

    const formatOptions = { ...defaultOptions, ...options };

    return new Intl.DateTimeFormat(navigator.language, formatOptions).format(
        validDate
    );
};
